/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const PaymentDetailsFormatter = (cellContent, row, rowIndex) => {
  const { paymentDetailsLastFour = "0" } = row;

  return (
    <>
      <div>{paymentDetailsLastFour ? paymentDetailsLastFour : "-"}</div>
      <> </>
    </>
  );
};
